import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router'
import { LoginService } from 'src/app/login.service';
import { EmailNotificationService } from '../email-notification.service';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-email-notification-list',
  templateUrl: './email-notification-list.component.html',
  styleUrls: ['./email-notification-list.component.css']
})
export class EmailNotificationListComponent implements OnInit, AfterViewInit {

  dataTable: any;
  userData: any;
  settingsList: any[] = [];

  constructor(
    private router: Router,
    private loginService: LoginService,
    private emailNotificationService: EmailNotificationService
  ) { }

  ngOnInit() {
    this.userData = this.loginService.getUserdata(true);
    this.initializeDatatable();
  }

  ngAfterViewInit(): void {
    this.updateDataTable();
  }

  onCreate() {
    this.router.navigate(["/email-notification-create"])
  }

  initializeDatatable() {
    this.dataTable = $('#settingsTable').DataTable({
      responsive: true,
      lengthChange: false,
      autoWidth: false,
      language: {
        emptyTable: 'No data available'
      },
      buttons: [],
      columns: [
        { data: 'slno', title: 'Sl No' },
        { data: 'name', title: 'Name' },
        { data: 'notification_type_name', title: 'Notification type' },
        { data: 'status', title: 'Status' },
        { data: 'action', title: "Action" }
      ]
    });
  }


  updateDataTable() {
    const qParams = [
      { key: "scope", value: "by_user" },
      { key: "user_profile", value: this.userData.id }
    ]

    this.emailNotificationService.listEmailNotification(qParams).subscribe((res: any) => {
      if (res.status === "1") {
        this.settingsList = res.data.map((item, index) => ({
          ...item,
          slno: index + 1,
          action: `<a id="btn-edit"><span class="icon has-text-dark"><i class="fa fa-edit" aria-hidden="true"></i></span></a>
                    <a id="btn-delete"><span class="icon has-text-dark"><i class="fa fa-trash-o"></i></span></a>`,
          status: `<input type="checkbox" ${item.enabled ? "checked" : ""} disabled/>`
        }))
        this.dataTable.clear();
        this.dataTable.rows.add(this.settingsList);
        this.dataTable.draw();

        $('#settingsTable tbody').on('click', '#btn-delete', (event: any) => {

          const row = this.dataTable.row($(event.target).closest('tr')).data();
          if (row) {
            this.deleteSettings(row.id);
          }
        });

        $('#settingsTable tbody').on('click', '#btn-edit', (event: any) => {

          const row = this.dataTable.row($(event.target).closest('tr')).data();
          if (row) {
            this.editSettings(row.id);
          }
        });
      }
    })
  }

  deleteSettings(id) {
    Swal.fire({
      title: "Are you sure ?",
      text: "The settings will be deleted",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete.",
      cancelButtonText: "No, Dont delete.",
    }).then((res) => {
      if (!res.dismiss) {
        this.emailNotificationService.deleteEmailNotification(id).subscribe((res: any) => {
          if (res.status === "1") {
            Swal.fire("Success", "Settings deleted successfully.", "success");
            this.updateDataTable();
          } else {
            Swal.fire("Something went wrong", "Failed to delete settings", "error");
          }
        })
      }
    })
  }

  editSettings(id) {
    this.router.navigate([`email-notification-create/${id}`]);
  }

}
